import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { environment } from '../../../environments/environment';
import { DEBUG_LOGS_KEY, DEBUG_LOG_STORE_STRATEGY } from '../../constants';
import { AuthService } from '../../services/auth.service';
import { CommonProvider } from '../../services/common';

@Component({
    selector: 'debug-menu',
    templateUrl: 'debug-menu.html',
    styleUrls: ['debug-menu.scss'],
    standalone: false
})
export class DebugMenu {
  selectedLogStoringStrategy = 'none'

  constructor(
    private viewCtrl: ModalController,
    private common: CommonProvider,
    private auth: AuthService
  ) {
    // const configuredStrategy = localStorage.getItem(DEBUG_LOG_STORE_STRATEGY)

    // if (['none', 'buffer', 'all'].includes(configuredStrategy)) {
    //   this.selectedLogStoringStrategy = configuredStrategy;
    // } else {
    //   this.selectedLogStoringStrategy = 'none'  
    // }
  }

  // onLogStrategyChange(value: 'none' | 'buffer' |'all') {
  //   this.selectedLogStoringStrategy = value;
  //   localStorage.setItem(DEBUG_LOG_STORE_STRATEGY, value)

  //   if (value === 'buffer' || value === 'all') {
  //     this.auth.initializeLogStoring();
  //   }
  // }

  async sendLogsToServer() {
    await this.common.withLoading(() => this.auth.logErrors(`Syncing logs` + localStorage.getItem(DEBUG_LOGS_KEY)), { loadingText: 'Sending errors' })
  }

  copyLogsToClipboard() {
    this.common.toast('Copied to clipboard');
    this.common.copyToClipboard(localStorage.getItem(DEBUG_LOGS_KEY) || '')
  }

  resetLogs() {
    localStorage.removeItem(DEBUG_LOGS_KEY)
  }

  copyEnvVariables() {
    this.common.toast('Copied to clipboard');
    this.common.copyToClipboard(JSON.stringify(environment, null, 2))
  }

  close() {
    this.viewCtrl.dismiss();
  }
}
